var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.905,
    viewBox: "0 0 16 9.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "increase_11073410",
    transform: "translate(-147 -443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185694",
    "data-name": "Group 185694",
    transform: "translate(147 443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63368",
    "data-name": "Path 63368",
    d: "M147.111,443.493l5.333-5.333a.381.381,0,0,1,.539,0l2.778,2.778,3.271-3.271-1.254-1.254a.381.381,0,0,1,.207-.645l4.571-.762a.381.381,0,0,1,.438.438l-.762,4.571a.381.381,0,0,1-.645.207l-1.254-1.255-4.3,4.3a.381.381,0,0,1-.539,0l-2.778-2.778-4.3,4.3a.381.381,0,0,1-.539,0l-.762-.762A.381.381,0,0,1,147.111,443.493Z",
    transform: "translate(-147 -435)",
    fill: "#0EAA57",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseGraph);
export default __webpack_public_path__ + "static/media/increaseGraph.39f6fa8f77f6d4fd324ae636e1b05670.svg";
export { ForwardRef as ReactComponent };